import { Component, Inject, Mixins } from '@/vue-property-decorator'
import { _GameNameNormalBase as GameNameNormalBase } from './cssVar/gameNameNormalBase'
import { _GameNameNormalDefault as GameNameNormalDefault } from './cssVar/gameNameNormalDefault'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { SquareProps } from '../../components/basePropsConfig'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type GameNameNormalCssVarManager = GetCssVarManager<GameNameNormalBase>
export { GameNameNormalBase }
export type GameNameNormalCssVar = {
  /** 游戏名称字号 */
  ['--game-name-font-size']?: string
}
@Component<GameNameNormal>({
  name: 'GameNameNormal'
})
export default class GameNameNormal extends Mixins<
  BaseCssVarInject<GameNameNormalBase>
>(BaseCssVarInject) {
  /** 获得转化样式cssVar变量 */
  public static getCssVarDefault = () => new GameNameNormalDefault()

  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<SquareProps>

  render() {
    const { gameName } = this.cardProps
    return (
      <div
        class={{
          ['game-name']: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType),
          [style['game-name']]: true
        }}
      >
        <div
          class={{
            ['game-name-inner']: true,
            [style['game-name-inner']]: true
          }}
        >
          {gameName}
        </div>
      </div>
    )
  }
}
